export default "__VITE_ASSET__DOWhwPHD__"